import axios from "axios"

const checkAuth = (onLogin = false) => {
    /*  Getting token value stored in localstorage, if token is not present we will open login page
        for all internal dashboard routes  */
    const TOKEN = localStorage.getItem("token")
    //TODO:: 로그인이 불필요한 라우터 정의
    const PUBLIC_ROUTES = ["login", "forgot-password", "reset-password", "register", "register-company", "documentation"]
    const isPublicPage = PUBLIC_ROUTES.some(r => window.location.href.includes(r))

    if (!TOKEN && !isPublicPage) {
        window.location.href = "/login"
        return false;
    } else {
        if (!isPublicPage || onLogin) {
            axios.defaults.headers.common['authorization'] = `${TOKEN}`
            return TOKEN
        }

    }
}

export default checkAuth